<div class="survey-widget" [class.ready]="showSurvey && currentSurvey && currentQuestion && surveyReady" *ngIf="showSurvey">
  
  <!-- Close button -->
  <button class="close-button" (click)="onCloseSurvey()" [attr.aria-label]="'Close survey'">
    <ion-icon name="close" size="small"></ion-icon>
  </button>

  <!-- Question state -->
  <div class="survey-content" *ngIf="surveyState === 'question' && currentSurvey && currentQuestion && surveyReady">
    <div class="survey-header">
      <h3 class="survey-title" *ngIf="!isSingleQuestionSurvey">{{currentSurvey.name}}</h3>
    </div>

    <div class="question-content" [class.fade-out]="isTransitioning">
      <h4 class="question-prompt" [class.primary-title]="isSingleQuestionSurvey">{{currentQuestion.prompt}}</h4>

      <!-- Multiple Choice Question -->
      <div class="question-options" *ngIf="currentQuestion.type === 'MULTIPLE_CHOICE'">
        <ion-radio-group [(ngModel)]="selectedAnswer" (ngModelChange)="onAnswerChange($event)">
          <ion-item *ngFor="let option of questionOptions" class="option-item" (click)="selectedAnswer = option; onAnswerChange(option)">
            <ion-radio [value]="option" slot="start"></ion-radio>
            <ion-label>{{option}}</ion-label>
          </ion-item>
        </ion-radio-group>
      </div>

      <!-- Rating Question -->
      <div class="question-rating" *ngIf="currentQuestion.type === 'RATING'">
        <ion-radio-group [(ngModel)]="selectedAnswer" (ngModelChange)="onAnswerChange($event)">
          <ion-item *ngFor="let option of questionOptions" class="option-item" (click)="selectedAnswer = option; onAnswerChange(option)">
            <ion-radio [value]="option" slot="start"></ion-radio>
            <ion-label>{{option}}</ion-label>
          </ion-item>
        </ion-radio-group>
      </div>

      <!-- Text Question -->
      <div class="question-text" *ngIf="currentQuestion.type === 'TEXT'">
        <ion-textarea
          [(ngModel)]="selectedAnswer"
          (ngModelChange)="onAnswerChange($event)"
          placeholder="Enter your answer..."
          rows="3"
          class="custom-textarea"
        ></ion-textarea>
      </div>

      <!-- Number Question -->
      <div class="question-number" *ngIf="currentQuestion.type === 'NUMBER'">
        <ion-input
          [(ngModel)]="selectedAnswer"
          (ngModelChange)="onAnswerChange($event)"
          type="number"
          placeholder="Enter a number..."
          class="custom-input"
        ></ion-input>
      </div>

      <!-- Thumbs Question -->
      <div class="question-thumbs" *ngIf="currentQuestion.type === 'THUMBS'">
        <ion-radio-group [(ngModel)]="selectedAnswer" (ngModelChange)="onAnswerChange($event)">
          <ion-item *ngFor="let option of questionOptions" class="option-item" (click)="selectedAnswer = option; onAnswerChange(option)">
            <ion-radio [value]="option" slot="start"></ion-radio>
            <ion-label>{{option}}</ion-label>
          </ion-item>
        </ion-radio-group>
      </div>
    </div>

    <!-- Submit button (hidden for multiple choice/rating in multi-question surveys) -->
    <div class="survey-actions" *ngIf="showSubmitButton()">
      <ion-button
        expand="block"
        class="submit-button"
        [disabled]="!isValidAnswer() || isSubmitting"
        (click)="onSubmitAnswer()"
      >
        <ion-spinner *ngIf="isSubmitting" size="small"></ion-spinner>
        <span *ngIf="!isSubmitting">Submit</span>
      </ion-button>
    </div>

    <!-- Progress Bar (only show for multi-question surveys) -->
    <div class="progress-container" *ngIf="totalQuestions > 1">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="((currentQuestionIndex + 1) / totalQuestions) * 100"></div>
      </div>
      <div class="progress-text">
        {{ currentQuestionIndex + 1 }} of {{ totalQuestions }}
      </div>
    </div>
  </div>

  <!-- Thank you state -->
  <div class="survey-content thank-you-content" *ngIf="surveyState === 'thank-you'">
    <!-- Auto-close progress bar -->
    <div class="auto-close-progress-bar" [class.fade-out]="!progressBarVisible">
      <div class="progress-fill" [style.width.%]="autoCloseProgress"></div>
    </div>
    
    <div class="thank-you-header">
      <h3 class="thank-you-title">Thank you for your feedback!</h3>
      <p class="thank-you-subtitle">Anything else you would like for us to know?</p>
    </div>

    <div class="feedback-content">
      <ion-textarea
        [(ngModel)]="additionalFeedback"
        (ionFocus)="onFeedbackFocus()"
        (ionInput)="onFeedbackFocus()"
        placeholder="Share any additional thoughts..."
        rows="3"
        class="custom-textarea"
      ></ion-textarea>
    </div>

    <div class="survey-actions">
      <ion-button 
        expand="block" 
        class="submit-button"
        [disabled]="isSubmitting"
        (click)="onSubmitFeedback()"
      >
        <ion-spinner *ngIf="isSubmitting" size="small"></ion-spinner>
        <span *ngIf="!isSubmitting">Submit</span>
      </ion-button>
    </div>
  </div>
</div>